import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
export function Card({
  className = '',
  children,
  ...props
}: CardProps) {
  return <div className={`rounded-xl border border-slate-200 bg-white text-slate-950 shadow-sm ${className}`} {...props} data-id="element-381">
      {children}
    </div>;
}
export function CardHeader({
  className = '',
  children,
  ...props
}: CardProps) {
  return <div className={`flex flex-col space-y-1.5 p-6 ${className}`} {...props} data-id="element-382">
      {children}
    </div>;
}
export function CardContent({
  className = '',
  children,
  ...props
}: CardProps) {
  return <div className={`p-6 pt-0 ${className}`} {...props} data-id="element-383">
      {children}
    </div>;
}
export function CardFooter({
  className = '',
  children,
  ...props
}: CardProps) {
  return <div className={`flex items-center p-6 pt-0 ${className}`} {...props} data-id="element-384">
      {children}
    </div>;
}